import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-t",
  "use": "arrow-t-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-t\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.332 6.35A.48.48 0 008 6.223a.459.459 0 00-.329.129c-1.025.976-1.913 1.945-2.888 2.942a.202.202 0 00.143.342h6.156a.2.2 0 00.144-.34c-.969-1.003-1.871-1.97-2.894-2.944z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol